"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const x5_gmaps_1 = require("x5-gmaps");
let InmuebleMapa = class InmuebleMapa extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.options = {
            zoom: this.zoom,
            center: this.coords,
            backgroundColor: "#aadaff",
        };
        this.streetView = false;
        this.tabMap = true;
        this.tabStreetView = false;
    }
    showMapa(e) {
        e.preventDefault();
        this.tabMap = true;
        this.tabStreetView = false;
    }
    showStreetView(e) {
        e.preventDefault();
        this.tabMap = false;
        this.tabStreetView = true;
        if (this.streetView === false) {
            console.log("cargando");
            this.$GMaps().then((GMaps) => {
                const panorama = new GMaps.StreetViewPanorama(document.getElementById("steet"), {
                    position: this.coords,
                    pov: { heading: 270, pitch: 0 },
                });
                this.$refs.mapa.map.setStreetView(panorama);
            });
            this.streetView = true;
        }
    }
};
__decorate([
    vue_property_decorator_1.Prop({ type: Object, required: true }),
    __metadata("design:type", Object)
], InmuebleMapa.prototype, "coords", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Number, required: false, default: 13 }),
    __metadata("design:type", Number)
], InmuebleMapa.prototype, "zoom", void 0);
InmuebleMapa = __decorate([
    vue_property_decorator_1.Component({ components: { gmapsMap: x5_gmaps_1.gmapsMap, gmapsMarker: x5_gmaps_1.gmapsMarker } })
], InmuebleMapa);
exports.default = InmuebleMapa;
